import React from "react"

import PropTypes from "prop-types"

import * as styles from "./columns.module.scss"
import CopyContainer from "../../atoms/copy-container"
import Grid from "../../atoms/grid"
import ButtonGroup from "../button-group"

const Columns = ({ data }) => (
  <Grid tight col={data.length}>
    {data.map((column) => (
      <div className={styles[`${column.custom_class}`]}>
        <div
          className={`${column.border ? styles.column__border : ""} ${
            column.border && column.color
              ? styles[`column__${column.color.replace("-", "")}`]
              : ""
          } ${styles[`column__${column.alignment}`]}`}
        >
          {column.custom_class === "membershipLogos" ? (
            <>
              <CopyContainer content={column._rawContent} />
              <CopyContainer content={column._rawContent} />
            </>
          ) : (
            <>
              <CopyContainer content={column._rawContent} />
              {column.ctas.length > 0 ? (
                <ButtonGroup ctas={column.ctas} alignment={column.alignment} />
              ) : (
                ""
              )}
            </>
          )}
        </div>
      </div>
    ))}
  </Grid>
)

export default Columns

Columns.propTypes = {
  data: PropTypes.array.isRequired,
}
